import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-bold font-heading text-background-50">汗汗漫画</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                汗汗漫画官网，提供好看的韩国漫画大全、日本漫画、国产漫画等丰富资源。设有虫虫漫画免费漫画弹窗入口，资源互联互通。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {comicCategories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <Link to="/category/korean-manhwa" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">韩国漫画</Link>
                </li>
                <li>
                  <Link to="/category/japanese-manga" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">日本漫画</Link>
                </li>
                <li>
                  <Link to="/category/chinese-manhua" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">国产漫画</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap">虫虫漫画入口</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门漫画</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/comic-001" className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1">首尔的秘密</Link>
                </li>
                <li>
                  <Link to="/article/comic-011" className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1">总裁的替身新娘</Link>
                </li>
                <li>
                  <Link to="/article/comic-002" className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1">剑与魔法学院</Link>
                </li>
                <li>
                  <Link to="/article/comic-007" className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1">血族伯爵</Link>
                </li>
                <li>
                  <Link to="/article/comic-008" className="text-sm text-background-400 hover:text-primary-400 transition-colors line-clamp-1">一拳超人传</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 汗汗漫画官网 - 好看的韩国漫画大全。版权所有。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500">虫虫漫画免费漫画弹窗入口</span>
              <span className="text-xs text-background-500">资源互联互通</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}